module.exports = "/_next/static/images/lowest_performers_mobile-08f058a270511cd4eab33a6b1153b498.jpeg";